const defaultState = {
  data: [],
};

const infoFeed = function (state = defaultState, action) {
  let data, id, message, existingIndex;

  switch (action.type) {
    case "SET_INFO_FEED_MESSAGE":
      data = Array.from(state.data);
      if (typeof action.data === "object") {
        message = {
          id: action.data.id,
          timeoutLength: action.data.timeoutLength || 6000,
          msg: action.data.msg,
          onClick: action.data.onClick,
          onClickName: action.data.onClickName,
          cantClose: action.data.cantClose,
        };
      } else {
        message = {
          id: action.data.split(" ").join("_"),
          timeoutLength: 6000,
          msg: action.data,
        };
      }

      //check if the message exists
      existingIndex = data.findIndex((d) => d.id === message.id);
      if (existingIndex > -1) {
        data[existingIndex] = message;
      } else {
        data.unshift(message);
      }

      return { ...state, data };

    case "REMOVE_INFO_FEED_MESSAGE":
      data = state.data.filter((d) => d.id !== action.data);
      return { ...state, data };

    case "CLEAR_ALL":
      return { ...state, data: [] };

    default:
      return state;
  }
};

export default infoFeed;
